"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfaSection = void 0;
const ui_1 = require("@app/component/ui");
const setup_mfa_1 = require("@app/component/modals/setup-mfa");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const use_plugin_1 = require("@app/util/hooks/use-plugin");
const use_modal_1 = require("@app/util/modal/use-modal");
const react_1 = __importDefault(require("react"));
const employee_card_context_1 = require("../../util/employee-card-context");
const mfa_factor_row_1 = require("./mfa-factor-row");
const hasType = (factor) => (0, util_1.isValue)(factor?.type);
const MfaSection = () => {
    const { workspace } = (0, employee_card_context_1.useEmployeeCard)();
    const { addModal } = (0, use_modal_1.useModal)();
    const { isPluginEnabled } = (0, use_plugin_1.usePlugin)();
    const mfa = (0, store_1.useRootSelector)((state) => state.me.mfa);
    const factors = react_1.default.useMemo(() => (mfa?.factors ?? []).filter(hasType), [mfa?.factors]);
    // same filter SetupMFA uses to build its method options
    const canAddMethod = react_1.default.useMemo(() => {
        const verifiedTypes = factors.filter((f) => f.verified === true).map((f) => f.type);
        const allowedMethods = workspace?.settings?.mfa?.allowedMethods ?? [];
        return isPluginEnabled('mfa') && allowedMethods.some((m) => (0, util_1.isValue)(m) && !verifiedTypes.includes(m));
    }, [factors, workspace?.settings?.mfa?.allowedMethods, isPluginEnabled]);
    // the backend asks for MFA at login whenever a verified factor exists, even with the
    // plugin off - so the section must stay reachable for anyone who still has factors to remove
    if (!isPluginEnabled('mfa') && factors.length === 0)
        return null;
    return (react_1.default.createElement(ui_1.Flex, { direction: ui_1.Flex.DIRECTION.COLUMN, testid: 'mfa-section' },
        react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_16 }),
        react_1.default.createElement(ui_1.Separator, null),
        react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_16 }),
        react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_LARGE, weight: ui_1.Text.WEIGHTS.BOLD, text: (0, util_1.t)('MFA_SETTINGS') }),
        react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_8 }),
        react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_MEDIUM, color: ui_1.Text.COLORS.GRAY, text: (0, util_1.t)('2FA_SUBTITLE') }),
        react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_16 }),
        factors.map((factor) => (react_1.default.createElement(react_1.default.Fragment, { key: factor.type },
            react_1.default.createElement(mfa_factor_row_1.MfaFactorRow, { factor: factor }),
            react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_8 })))),
        canAddMethod && (react_1.default.createElement(ui_1.Flex, null,
            react_1.default.createElement(ui_1.Button, { style: ui_1.Button.STYLES.CONTAINED, label: mfa?.enabled === true ? (0, util_1.t)('NEW_FACTOR') : (0, util_1.t)('ENABLE_2FA'), testid: 'mfa-add-method-button', onClick: () => addModal(setup_mfa_1.SetupMFA, { mode: 'setup' }) })))));
};
exports.MfaSection = MfaSection;
